// extracted by mini-css-extract-plugin
module.exports = {"container":"venting-gas_container__3HeTy","button":"venting-gas_button__zVYpn"};